import React, { useState } from "react";
import { Link } from "react-router-dom";
import CalendarIcon from "../../assets/image/hindupanchang.png";
import KundliMatchingIcon from "../../assets/image/kundli.png";
import ShopIcon from "../../assets/image/shop.png";
import PoojaIcon from "../../assets/image/bookpuja (3).png";

// Add your card images (500x200 recommended)
import KundliCardImg from "../../assets/image/matchmatching.png";
import MatchCardImg from "../../assets/image/matching.png";

import "./SidebarOptions.css";

const SidebarOptions = () => {
  const [showPopup, setShowPopup] = useState(false);

  const options = [
    {
      img: PoojaIcon,
      title: "Book A Puja",
      link: "/Homan",
    },
    {
      img: CalendarIcon,
      title: "Hindu Panchang",
      link: "/panchang",
    },
    {
      img: KundliMatchingIcon,
      title: "Vedic Astrology",
      isPopup: true,
    },
    {
      img: ShopIcon,
      title: "Jyotirvani Shop",
      link: "/ShopCategoryCard",
    },
  ];

  return (
    <div className="container">
      <div className="sidebar">
        {options.map((opt, index) => (
          <div className="sidebar-card" key={index}>
            <img src={opt.img} alt={opt.title} className="sidebar-img" />

            {!opt.isPopup ? (
              <Link to ={opt.link}>
                <button className="sidebar-btn">{opt.title}</button>
              </Link>
            ) : (
              <button className="sidebar-btn" onClick={() => setShowPopup(true)}>
                {opt.title}
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Popup Modal with Blur Background */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3 className="popup-title">Select Option</h3>
            <div className="popup-cards">
              <a href="/D1chart" className="popup-card">
                <img src={MatchCardImg} alt="Kundli" />
                <p>Kundli</p>
              </a>
              <Link to="/Ashtakoot" className="popup-card">
                <img src={KundliCardImg} alt="Match Matching" />
                <p>Match Matching</p>
              </Link>
            </div>
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarOptions;
